import { AimOutlined, BorderOutlined, EditOutlined } from '@ant-design/icons';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { MapDrawingRadioButton } from '../radio-button/MapDrawingRadioButton.tsx';
import { type IdentifySelectionMode } from './useMapIdentifyInteractions.ts';

export interface IMapIdentifySelectionControlsProps {
  selectionMode: IdentifySelectionMode;
  onSelectionModeChange: (mode: IdentifySelectionMode) => void;
  isMobile?: boolean | null;
}

/**
 * Controlli per la sotto-modalita' di selezione identify:
 * punto, rettangolo o poligono.
 */
export function MapIdentifySelectionControls(
  props: IMapIdentifySelectionControlsProps,
) {
  const { selectionMode, onSelectionModeChange, isMobile } = props;
  const { t } = useTranslation();

  return (
    <div>
      <Radio.Group
        buttonStyle="solid"
        size="small"
        onChange={e => {
          onSelectionModeChange(e.target.value ?? 'point');
        }}
        value={selectionMode}
      >
        <MapDrawingRadioButton
          isMobile={isMobile}
          label={t('mappa.identify.punto', {
            defaultValue: 'Punto',
          })}
          value="point"
          icon={<AimOutlined aria-hidden="true" />}
        />
        <MapDrawingRadioButton
          isMobile={isMobile}
          label={t('mappa.identify.rettangolo', {
            defaultValue: 'Rettangolo',
          })}
          value="rectangle"
          icon={<BorderOutlined aria-hidden="true" />}
        />
        <MapDrawingRadioButton
          isMobile={isMobile}
          label={t('mappa.identify.poligono', {
            defaultValue: 'Poligono',
          })}
          value="polygon"
          icon={<EditOutlined aria-hidden="true" />}
        />
      </Radio.Group>
    </div>
  );
}
